import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const restrictedBlends =
{
    namespaced: true,
    state: {
        restrictedBlends: [],
        restrictedBlend: {}
    },
    mutations: {
        SET_RESTRICTEDBLENDS(state, data) {
            state.restrictedBlends = data
        },
        SET_RESTRICTEDBLEND(state, data) {
            state.restrictedBlend = data
        }
    },
    actions: {

        addRestrictedBlend({ commit }, data) {
            return axios
                .post(baseUrl + 'RestrictedBlend/addRestrictedBlend', data, { withCredentials: true }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
                )
                .then(res => {
                    console.log("RestrictedBlend Added:", res.data);
                    commit('SET_RESTRICTEDBLEND', {successInt: res.data});
                })
                .catch(error => console.log("Error Adding Classification:", error));
        },

        getAll({ commit }) {
            return axios
                .get(baseUrl + 'RestrictedBlend', { withCredentials: true })
                .then(res => {
                    //   console.log(res.data);
                    commit('SET_RESTRICTEDBLENDS', res.data);
                    return res.data.data;
                })
                .catch(error => console.log(error))
        },

        deleteRestrictedBlend({ commit }, id) {
            return axios
                .get(baseUrl + 'DeleteVendor?vendorId=' + id, { withCredentials: true })
                .catch(error => console.log(error))
        },
        updateRestrictedBlend({ commit }, { id, data }) {
            console.log(data);
            return axios
                .post(baseUrl + 'RestrictedBlend/updateRestrictedBlend/' + id, data, { withCredentials: true }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(res => {
                    console.log(res)
                    commit('SET_RESTRICTEDBLENDS', res.data)
                })
        },

        //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
        getRestrictedBlend({ commit }, id) {
            return axios
                .get(baseUrl + 'GetVendor/' + id, { withCredentials: true })
                .then(res => {
                    commit('SET_RESTRICTEDBLEND', res.data)
                })
                .catch(error => console.log(error))
        },
        // addClassification({ commit }, classificationInfo) {
        //     return axios
        //         .post(baseUrl + 'AddGHSClassification', classificationInfo)
        //         .then(res => {
        //             console.log(res.data)
        //             // commit('SET_VENDOR', res.data)
        //         })
        //         .catch(error => console.log(error))
        // }
    },
    getters: {}
}

export default restrictedBlends